import React, { useEffect, useState } from 'react';
// import classNames from 'classnames';
import styles from './RadioGroup.module.less';
import Radio from './Radio';

export default ({
  group,
  handleChange,
  radioGroupStyle = {},
  radioBoxStyle = {},
  radioStyle = {},
  iconStyle = {},
}) => {
  const [radioGroup, setRadioGroup] = useState([]);
  useEffect(() => {
    if (group && Array.isArray(group)) {
      setRadioGroup(group);
    }
  }, [group]);
  const handleChangeRadio = itemValue => () => {
    if (handleChange) {
      handleChange(itemValue);
    }
    // 设置选中的单选样式
    setRadioGroup(list => {
      return list.map(item => ({
        ...item,
        selected: item.name === itemValue.name,
      }));
    });
  };
  return (
    <div className={`${styles.radio_group} ${radioGroupStyle}`}>
      {radioGroup.map(item => (
        <div key={item.name} className={`${styles.radio_box} ${radioBoxStyle}`}>
          <Radio
            radioStyle={radioStyle}
            iconStyle={iconStyle}
            selected={item.selected}
            handleChange={handleChangeRadio(item)}
          >
            <span className={styles.radio_text}>{item.text}</span>
          </Radio>
        </div>
      ))}
    </div>
  );
};
